<template>
  <div class="d-flex">
    <v-button
      type="button"
      rounded
      class="feed__subscribe-button"
      :secondary="isOn"
      :is-loading="isToggling"
      @click="toggleSubscribe"
    >
      <template v-if="!isOn">
        <v-icon icon="notifications_active" size="16px" class="mr-1" />
        {{ $t("components.messageThread.subscribeButton.subscribe") }}
      </template>
      <template v-else>
        <v-icon icon="notifications_off" />
      </template>
    </v-button>

    <alert-dialog
      :title="$t('components.messageThread.subscribeButton.dialogTitle')"
      :actions="[
        {
          title: $t('components.messageThread.subscribeButton.dialogCancel'),
          callback: () => (this.showUnsubscribeDialog = false)
        },
        {
          title: $t(
            'components.messageThread.subscribeButton.dialogUnsubscribe'
          ),
          callback: toggle
        }
      ]"
      :show="showUnsubscribeDialog"
      @close="() => (this.showUnsubscribeDialog = false)"
      centered
    >
      {{ $t("components.messageThread.subscribeButton.dialogContent") }}
    </alert-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex"

import EventBus, { EVENTS } from "@/lib/event-bus"

export default {
  props: {
    messageThreadId: { type: [String, Number], required: true }
  },

  components: {
    AlertDialog: () => import("@/components/AlertDialog")
  },

  data() {
    return {
      isToggling: false,
      showUnsubscribeDialog: false
    }
  },

  computed: {
    ...mapGetters("auth", ["isAuthenticated"]),
    ...mapGetters("messages", ["getParticipant"]),

    isOn() {
      return this.getParticipant(this.messageThreadId)?.notifications_enabled
    }
  },

  methods: {
    ...mapActions("messages", ["toggleNotification"]),

    toggle() {
      if (!this.isAuthenticated) {
        return this.$router.push("#auth")
      }

      this.isToggling = true

      this.toggleNotification({
        messageThreadId: this.messageThreadId,
        active: !this.isOn
      })
        .then(active => {
          if (active) {
            EventBus.$emit(EVENTS.PROMPT_PUSH_PERMISSION, {
              ignoreDismissed: true
            })
            this.$emit("enabled")
          }

          this.$notify(
            active
              ? this.$t(
                  "components.messageThread.subscribeButton.enableNotification"
                )
              : this.$t(
                  "components.messageThread.subscribeButton.disabledNotification"
                )
          )
        })
        .finally(() => {
          this.isToggling = false
          this.showUnsubscribeDialog = false
        })
    },

    toggleSubscribe() {
      if (this.isOn) {
        this.showUnsubscribeDialog = true
      } else {
        this.toggle()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables";

.feed__subscribe-button {
  padding-left: $size--4;
  padding-right: $size--4;

  font-size: $size--4;
}
</style>
